// extracted by mini-css-extract-plugin
export var box = "_7t-1";
export var checked = "_7t-2";
export var descriptionSpacer = "_7t-9";
export var disabled = "_7t-3";
export var icon = "_7t-6";
export var input = "_7t-0";
export var labelSpacer = "_7t-8";
export var medium = "_7t-5";
export var small = "_7t-4";
export var text = "_7t-7";